import { render } from "./ExportButton.vue?vue&type=template&id=b099a3ca&ts=true"
import script from "./ExportButton.vue?vue&type=script&lang=ts"
export * from "./ExportButton.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/mmwapp/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__